export const MAX_QUANITY_PER_PRODUCT = 4;
